import ProfileRowInfo from './ProfileRowInfo';
import { ProfileProps } from '../ProfilePage';
import { useTranslation } from 'react-i18next';
import { StyledTitle } from 'components/StyledTitle';
import React, { useState } from 'react';
import { Button, Card, Modal, Typography, Grid, Form, Input, Col } from 'antd';
import './ProfileAccountInfo.less';
import { useNavigate } from 'react-router-dom';
const { Title, Text } = Typography;
import Close from 'assets/images/liHome/close.svg';
const { useBreakpoint } = Grid;
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { setErrorCodeFun } from 'utils/setErrorCodeFun/setErrorCodeFun';
import { osName, osVersion } from 'react-device-detect';
import jwtDecode from 'jwt-decode';

import { useValidSecEmail, useSwitchEbPolicy } from 'all-in-one-shared-api';
import styled from 'styled-components';

export const InvalidTextMsg = styled(Text)`
  align-self: flex-start;
  // margin-left: 2.5rem;
`;

const ProfileAccountInfo = ({ data }: ProfileProps): JSX.Element => {
  const { t, i18n } = useTranslation();
  const countryCode = data?.countryCode ? data.countryCode : '';
  const mobile = data?.mobile ? data.mobile : '';
  // const email = data?.email ? data.email : '';
  const mobileNumber = `${countryCode}${mobile}`;
  const navigate = useNavigate();
  const { lg, xl } = useBreakpoint();
  const { keycloak } = useKeycloak();
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  const [showSecEmailModal, setShowSecEmailModal] = useState(false);
  const [form] = Form.useForm();

  const { shouldFetch: validSecEmailFetch } = useValidSecEmail(
    'useValidSecEmail',
    keycloak.token as string,
    form.getFieldValue('secEmail'),
    {
      onSuccess: (res) => {
        if (res) {
          validSecEmailFetch(false);
          navigate('/secOtpVerificationPage', {
            state: {
              secEmail: form.getFieldValue('secEmail'),
              loginId: data?.loginId,
            },
          });
          setShowSecEmailModal(false);
          setErrorMsg(null);
          form.resetFields();
        } else {
          validSecEmailFetch(false);
        }
      },
      onError: (err) => {
        const errorMessage = setErrorCodeFun(err.code, i18n.language);
        console.log(err.code, err.message, errorMessage);

        setErrorMsg(errorMessage ?? err.code ?? err.message);
        validSecEmailFetch(false);
      },
    },
  );
  const refreshToken = () => {
    const { preferred_username }: { preferred_username: string } = jwtDecode(keycloak.token ?? '');
    keycloak
      .login({
        action: 'refresh_token',
        username: preferred_username,
        refreshToken: keycloak.refreshToken,
        device: osName,
        deviceVersion: osVersion,
      })
      .then(() => {
        keycloak.updateToken(-1);
        console.log(keycloak.tokenParsed, '刷新之后');
        navigate(0);
      });
  };
  const [randoms, setRandoms] = useState(Math.random());
  const [retryCount, setRetryCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const { shouldFetch: SwitchEbPolicyFetch } = useSwitchEbPolicy(
    'useSwitchEbPolicy' + randoms,
    keycloak.token as string,
    {
      onSuccess: (res) => {
        setLoading(false);

        if (res) {
          SwitchEbPolicyFetch(false);
          refreshToken();
          setErrorMsg(null);
          setRetryCount(0);
        } else {
          SwitchEbPolicyFetch(false);
        }
      },
      onError: (err) => {
        const errorMessage = setErrorCodeFun(err.code, i18n.language);
        console.log(err.code, err.message, errorMessage);
        setLoading(false);
        setErrorMsg(errorMessage ?? err.code ?? err.message);
        SwitchEbPolicyFetch(false);

        if (retryCount < 2) {
          setRetryCount((prev) => prev + 1);
          setTimeout(() => {
            SwitchEbPolicyFetch(true);
          }, 1000);
        } else {
          setRetryCount(0);
          navigate('/ChangeRequestError');
        }
      },
    },
  );
  const onAddEbPolicy = () => {
    navigate('/EbProfileConnect');
  };
  const onSwitchEbPolicy = () => {
    console.log(keycloak.tokenParsed, '刷新之前');
    setLoading(true);
    setRandoms(Math.random());
    setRetryCount(0);
    SwitchEbPolicyFetch(true);
  };
  const onAddLifePolicy = () => {
    navigate('/ProfileConnectLife');
  };
  const addSecEmail = () => {
    setShowSecEmailModal(true);
  };
  const submitForm = async () => {
    try {
      const values = await form.validateFields();
      console.log('Received values:', values);
      // 在这里处理表单提交逻辑
      console.log(showSecEmailModal, data);
      validSecEmailFetch(true);
    } catch (errorInfo) {
      console.log('Failed:', errorInfo);
    }
  };

  return (
    <>
      <StyledTitle level={4} margin="32px 0 10px 0">
        {t('profile.accountInfo')}
      </StyledTitle>
      {data?.email && <ProfileRowInfo label={t('profile.email')} value={data.email} />}
      {data?.secondaryEmail && <ProfileRowInfo label={t('profile.secondaryEmail')} value={data.secondaryEmail} />}
      {mobileNumber && <ProfileRowInfo label={t('profile.mobile')} value={mobileNumber} />}
      {data?.loginId && <ProfileRowInfo label={t('login.selfDefinedIdLabel')} value={data.loginId} />}
      {!data?.secondaryEmail && (
        <Card className="addLifePolicy">
          <Button className="left-marin" onClick={addSecEmail}>
            {t('profile.secEmail')}
          </Button>
        </Card>
      )}
      {(data?.showIndicator == 'Y' || data?.showConnectIndicator == 'Y' || data?.showSwitchIndicator == 'Y') && (
        <Card className="addLifePolicy">
          {data?.showConnectIndicator == 'Y' && (
            <Button className="left-marin" onClick={onAddEbPolicy} disabled={false}>
              {t('profile.connectEB')}
            </Button>
          )}
          {data?.showSwitchIndicator == 'Y' && (
            <Button className="left-marin" onClick={onSwitchEbPolicy} disabled={false} loading={loading}>
              {t('profile.switchEB')}
            </Button>
          )}

          {data?.showIndicator == 'Y' && (
            <Button
              className={
                data?.showConnectIndicator != 'Y' && data?.showSwitchIndicator != 'Y' ? 'left-marin' : 'addLifeBtn'
              }
              onClick={onAddLifePolicy}
              disabled={false}
            >
              {t('profile.connectlife')}
            </Button>
          )}
        </Card>
      )}

      <Modal
        okText={t('common.submit')}
        cancelText={t('common.cancel')}
        open={showSecEmailModal}
        onCancel={() => {
          setShowSecEmailModal(false);
          setErrorMsg(null);
          form.setFieldValue('secEmail', '');
          form.resetFields();
        }}
        className="e-notice-modal sec-email"
        width={xl ? '900px' : 'calc(100% - 32px)'}
        closeIcon={<img src={Close} />}
        onOk={submitForm}
      >
        <div>
          <Title
            level={5}
            className={` ${lg ? 'font-size24' : 'font-size22'}`}
            style={{ fontWeight: 400, fontSize: '17px', fontFamily: 'Roboto400', whiteSpace: 'pre-line' }}
          >
            {t('profile.secDesc')}
          </Title>
          <Form form={form} layout="vertical" validateTrigger={'onBlur'}>
            <Col xs={24} md={24} style={{ position: 'relative' }}>
              <BoldLabelFormItem
                name="secEmail"
                label={<span style={{ fontWeight: 'normal', fontSize: '17px' }}>{t('profile.secEmailTitle')}</span>}
                rules={[
                  { required: true, message: t('registration.error.required') },
                  {
                    type: 'email',
                    message: t('registration.error.invalidEmail'),
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder={t('profile.secPlaceholder')}
                  onBlur={() => {
                    if (errorMsg) setErrorMsg(null);
                  }}
                />
              </BoldLabelFormItem>
            </Col>
            <Col
              xs={24}
              md={24}
              style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '-24px', alignItems: 'center' }}
            >
              {errorMsg && <InvalidTextMsg type="danger">{t(errorMsg)}</InvalidTextMsg>}
            </Col>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default ProfileAccountInfo;
